<div id="layout-wrapper">

  <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
  </app-topbar>

  <app-sidebar *ngIf="isVerticalSidebarRequested()" [isCondensed]="isCondensed"></app-sidebar>

  <app-settings-sidebar *ngIf="isSettingsSidebarRequested()" [isCondensed]="isCondensed"></app-settings-sidebar>

  <div class="main-content">
    <div class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>

    <!-- footer -->
    <app-footer></app-footer>
  </div>
</div>

